import styled from 'styled-components'

export const TableWrapper = styled.div`
  padding: 50px 0px 0px 0px;
`
